<app-fp-navbar/>

<!--about-->
<br><br>
<div class="breadcrumb-sec">
    <div class="container">
        <div class="flex justify-between items-center">
            <h4 class="w-50 !mb-0">
                Contact Us
            </h4>
            <ol class="breadcrumb m-0">
                <li class="breadcrumb-item inline-block relative">
                    <a [routerLink]="homeRoute" class="inline-block relative ltr:pl-[22px] rtl:pr-[22px] transition-all hover:text-primary-500">
                        <i class="material-symbols-outlined pr-2">
                            home
                        </i>
                        Home
                    </a>
                </li>
                
                <li class="breadcrumb-item inline-block relative">
                    <a [routerLink]="homeRoute" class="inline-block relative rtl:pr-[22px] transition-all hover:text-primary-500">
                        
                        Contact Us
                    </a>
                </li>
                
                <!-- <li class="breadcrumb-item">
                    Center Entry
                </li> -->
            </ol>
        </div>
    </div>
</div>


<!--contact-details-->
<div class="about-content">
    <div class="container">
        <div class="grid grid-cols-4 gap-4">
            <div class="col-span-2">
                <div class="image-sec">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d14736.20868280687!2d88.43091629999999!3d22.577151999999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3a02710d2c9719f5%3A0xfcac5856cee420ee!2sWTL%20Building%2C%20Plot%20-%205%2C%20beside%20Techno%20Polis%2C%20BP%20Block%2C%20Sector%20V%2C%20Bidhannagar%2C%20Kolkata%2C%20West%20Bengal%20700091!3m2!1d22.5787752!2d88.43784289999999!5e0!3m2!1sen!2sin!4v1764592449068!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </div>
        </div>
    </div>
</div>



<app-fp-footer/>
